import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "./App.scss";
import { setCurrentUser } from "./features/Auth/authSlice";
import { store } from "./features/store";
import PrivateRoute from "./common/layouts/PrivateRoute";
import OrderRequest from "./pages/Home/OrderRequest";
import CMSPageMobile from "./pages/Wallet/CMSPageMobile";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { colorsAsyncAction } from "./features/getColor/getColorSlice";
import "./index.scss";
toast.configure();

/* Layout */
const FrontLayout = React.lazy(() => import("./common/layouts/FrontLayout"));
const PersonaVerification = React.lazy(() =>
  import("./pages/Wallet/PersonaVerification")
);
const ComingSoonLayout = React.lazy(() =>
  import("./common/layouts/ComingSoonLayout")
);
// const PrivateRoute = React.lazy(() => import('./common/layouts/PrivateRoute'));
// const DashboardLayout = React.lazy(() => import('./common/layouts/DashboardLayout'));

/* Pages */
const PageNotFound = React.lazy(() =>
  import("./components/PageNotFound/PageNotFound")
);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
var jwt = require("jsonwebtoken");

if (localStorage.auth_security) {
  const token = localStorage.auth_security;
  var decoded = jwt.verify(token, process.env.REACT_APP_JWT_SECRET);
  store.dispatch(setCurrentUser(decoded));
}

function App() {
  // Retrieve user data from local storage

  useEffect(() => {
    // Retrieve color data from local storage
    const UserData = JSON.parse(localStorage.getItem("auth_data"));
    const vendor_color = UserData?.vendor_color;
    
    // Set CSS variables on document root
    if (vendor_color && Object.keys(vendor_color).length > 0) {
      Object.keys(vendor_color).forEach((key) => {
        document.documentElement.style.setProperty(
          `--${key}`,
          vendor_color[key]
        );
      });
    }
  }, []);

  return (
    <Router>
      <React.Suspense fallback={loading}>
        <Switch>
          {/* <Route exact path="/" name="ComingSoon" render={(props) => <ComingSoonLayout {...props} />} /> */}
          {window.self !== window.top?null: <Route exact path="/" name="Home" render={(props) => <FrontLayout {...props} />} /> }

          <Route
            exact
            path="/data/:dataval"
            name="Home"
            render={(props) => <FrontLayout {...props} />}
          />

          {/* Content Pages */}
          <Route
            exact
            path="/about-us"
            name="AboutUs"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/refer-earn"
            name="ReferAndEarn"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/aff-prog"
            name="Affiliate"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/scoring-system"
            name="ScoringSystem"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/frequently-asked-questions"
            name="FAQ"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/frequently-asked-questions/category/:id/:catname"
            name="FAQDetails"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/how-to-play"
            name="HowToPlay"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/security-legality"
            name="SecurityAndLegality"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/privacy-policy"
            name="PrivacyPolicy"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/terms-conditions"
            name="TermsAndConditions"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/contact-us"
            name="ContactUs"
            render={(props) => <FrontLayout {...props} />}
          />
          <Route
            exact
            path="/orderrequest"
            name="OrderRequest"
            render={(props) => <OrderRequest />}
          />
          <Route
            exact
            path="/responsible-gaming"
            name="ResponsibleGaming"
            render={(props) => <FrontLayout {...props} />}
          />

          <Route
            exact
            path="/persona-verification"
            name="PersonaVerification"
            render={(props) => <PersonaVerification {...props} />}
          />
          <Route
            exact
            path="/cms/mobile/:type"
            name="PersonaVerification"
            render={(props) => <CMSPageMobile {...props} />}
          />

          <Switch>
            {window.self !== window.top && <PrivateRoute
              path="/"
              name="MatchesList"
              component={(props) => <FrontLayout {...props} />}
            />}
            {/* Profile */}
            <PrivateRoute
              path="/profile"
              name="Profile"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/complete-profile"
              name="CompleteProfile"
              component={(props) => <FrontLayout {...props} />}
            />

            {/* Matches */}
            <PrivateRoute
              path="/matches"
              name="MatchesList"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/players/:sportType/:playerId/:playerName"
              name="PlayerDetails"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/teams/:sportType/:teamId/:teamName"
              name="PlayerDetails"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/player-accumulator"
              name="PlayerAccumulator"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/player-accumulator/:sportType/:matchID/player-preview"
              name="PlayerAccumulatorPreview"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/join-contest"
              name="JoinContest"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/create-contest"
              name="CreateContest"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/create-portfolio"
              name="CreatePortfolio"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/contests/:sportType/:poolID"
              name="MyContestDetails"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/select-team/:poolId"
              name="SelectExistingTeam"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/result"
              name="MatchResult"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/:sportType/live"
              name="MatchLive"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/match/:matchID/contests/:sportType/:poolID/:status/my-leaderboard/players"
              name="MyLeaderBoardPlayerList"
              component={(props) => <FrontLayout {...props} />}
            />

            {/* Series */}
            <PrivateRoute
              path="/series"
              name="SeriesList"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:sportType/:seriesID/team-accumulator"
              name="TeamAccumulator"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/team-accumulator/:sportType/:seriesID/team-preview"
              name="TeamAccumulatorPreview"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:sportType/:seriesID/prize-pool"
              name="PrizePool"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/prize-pool/:sportType/:seriesID/team-preview"
              name="PrizePoolPreview"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/join-contest"
              name="JoinSeriesContest"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/create-contest"
              name="CreateSeriesContest"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/create-portfolio"
              name="CreateSeriesPortfolio"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/:uteamid/add-substitute"
              name="AddPortfolioSubstitute"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/contests/:sportType/:poolID"
              name="MyContestSeriesDetails"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/select-team/:poolId"
              name="SelectSeriesExistingTeam"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/result"
              name="SeriesResult"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/series/:matchID/:sportType/live"
              name="SeriesLive"
              component={(props) => <FrontLayout {...props} />}
            />

            {/* Portfolio */}
            <PrivateRoute
              path="/portfolio/match-portfolio"
              name="MatchPortfolio"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/portfolio/series-portfolio"
              name="MatchPortfolio"
              component={(props) => <FrontLayout {...props} />}
            />

            <PrivateRoute
              path="/series/:leagueID/contests/:sportType/:poolID/:status/my-leaderboard/players/:contestID/edit"
              name="EditSeriesPlayer"
              component={(props) => <FrontLayout {...props} />}
            />

            {/* Wallet */}
            <PrivateRoute
              path="/wallet"
              name="Wallet"
              component={(props) => <FrontLayout {...props} />}
            />

            <PrivateRoute
              path="/transaction-history"
              name="TransactionHistory"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/verify/id-verification"
              name="IDVerification"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/verify/bank-verification"
              name="BankVerification"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/user-refer-earn"
              name="UserReferEarn"
              component={(props) => <FrontLayout {...props} />}
            />
            <PrivateRoute
              path="/verify/upi-verification"
              name="UpiVerification"
              component={(props) => <FrontLayout {...props} />}
            />

            <PrivateRoute
              path="/match_list/:sportType/:seriesID"
              name="SelectExistingTeam"
              component={(props) => <FrontLayout {...props} />}
            />

            <PrivateRoute
                path="/b2b" name="B2B"
                component={props => <FrontLayout {...props} />}
            />

            <PrivateRoute
                path="/c2" name="C2"
                component={props => <FrontLayout {...props} />}
            />
          </Switch>

          <Route component={PageNotFound} />
        </Switch>
      </React.Suspense>
    </Router>
  );
}

export default App;
